import { HttpClient, HttpResponse, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OAuthModule, OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Backend } from './core/base/backend';
import { DataModule } from './data/data.module';
import { WebBackend } from "./data/webBackend/web-backend";
import { CookieConsentService } from './services/cookie-consent.service';
import { SharedModule } from './shared/shared.module';
import { createTranslateLoader } from './translateHttpFactory';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';

// We need a factory, since localStorage is not available during AOT build time.
export function storageFactory() : OAuthStorage {
  return localStorage
}

export function whichRepoBackend(): any {
  return WebBackend;
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    SharedModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.apiUrl],
        sendAccessToken: true
      } 
    }),
    BrowserAnimationsModule,
    DataModule,
    MatToolbarModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatAutocompleteModule,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    CookieConsentService,
    { provide: OAuthStorage, useFactory: storageFactory, },
    { provide: Backend, useClass: whichRepoBackend() },
    provideMomentDateAdapter(),
    provideHttpClient(withInterceptorsFromDi()),
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export class OAuthNoopResourceServerErrorHandler implements OAuthResourceServerErrorHandler {

  handleError(err: HttpResponse<any>): Observable<any> {
      return throwError(err);
  }

}
